module.exports = __webpack_public_path__ + "static/media/mdb.b7381a96.svg";